import moment from 'moment';
import type { ProcessCellCallbackParams } from '../../../types/common';

const dateTimeCellCallback = (params: ProcessCellCallbackParams): string => {
  const value: string = params.value;
  const formattedValue: string = moment(value).isValid() ? moment(value).format('YYYY-MM-DD HH:mm:SS') : value;
  return formattedValue;
};

export default dateTimeCellCallback;
